import { render, staticRenderFns } from "./IconFormatLineSpacingDown.vue?vue&type=template&id=016a300b&scoped=true&"
import script from "./IconFormatLineSpacingDown.vue?vue&type=script&lang=ts&"
export * from "./IconFormatLineSpacingDown.vue?vue&type=script&lang=ts&"
import style0 from "./IconFormatLineSpacingDown.vue?vue&type=style&index=0&id=016a300b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a300b",
  null
  
)

export default component.exports